export default {"src":"/_next/static/media/google.cbf51a07.svg","height":20,"width":20};